import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { CircularProgress, Box, Typography } from "@mui/material";

interface PrivateRouteProps {
  children: ReactNode;
  requiredRole?: number;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  requiredRole,
}) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        minHeight='100vh'
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to='/login' />;
  }

  if (requiredRole && user?.roleID !== requiredRole) {
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        minHeight='100vh'
        flexDirection='column'
      >
        <Typography variant='h4' color='error'>
          Access Denied
        </Typography>
        <Typography variant='body1'>
          You do not have permission to access this page.
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
};
